import { useContext } from 'react';
import SnackbarContext from './../contexts/SnackbarContext';

export default function useSnackbarContext() {
  return useContext(SnackbarContext);
}